<template>
  <div class="list-control d-flex">
    <div
      v-if="!isDesktop"
      class="list-control__mobile d-flex flex-column justify-content-center"
    >
      <span
        v-click-outside="close"
        class="cursor-pointer"
        @click="open = !open"
      >
        <font-awesome-icon
          :icon="'cog'"
          size="lg"
        />
      </span>
      <transition-expand-side v-if="open" :expand-direction="'expand-side-left'">
        <div class="list-control__mobile__pane d-flex flex-column">
          <span
            class="close-pane ml-4 mb-md-4 cursor-pointer"
            @click="open = !open"
          >
            <font-awesome-icon
              :icon="['far', 'times-circle']"
              size="2x"
            />
          </span>
          <div class="list-control__mobile__pane__scrollable d-flex flex-column">
            <div class="d-flex flex-column">
              <template v-if="sortFields !== undefined && sortFields !== null">
                <select-accordion
                  v-model="sortBy"
                  :options="sortOptions"
                  name="Sort by"
                  class="text-left list-control__mobile__pane__item"
                  :accordion="'parent-accordion'"
                />
              </template>
              <slot name="contextual" />
            </div>
          </div>
        </div>
      </transition-expand-side>
    </div>
    <div
      v-else
      class="d-flex list-control__desktop"
    >
      <div class="d-flex justify-content-end filter">
        <slot name="contextual" />
      </div>
    </div>
  </div>
</template>

<script>
import SelectAccordion from "@/components/form/elements/SelectAccordion";
import userDevice from "@/imports/mixins/userDevice";
import TransitionExpandSide from "@/components/animation/TransitionExpandSide";

export default {
  name: "InvoicesListControl",
  components: {SelectAccordion, TransitionExpandSide},
  mixins: [userDevice],
  props: {
    sortFields: {
      default: null,
      type: Array,
    },
    storeKey: {
      type: String,
      default: 'global',
    },
    defaultOrder: {
      default: null,
      type: String
    },
  },
  data: function () {
    return {
      sortBy: null,
      open: false,
    }
  },
  computed: {
    sortOptions: function () {
      let filter = [];
      if (Array.isArray(this.sortFields)) {
        this.sortFields.forEach((column) => {
          if (column.canSort) {
            if (column.customSortLabels) {
              filter.push(
                {text: column.customSortLabels[0], value: column.key + '-desc'},
                {text: column.customSortLabels[1], value: column.key + '-asc'},
              );
            } else {
              filter.push(
                {text: column.label + ' Asc', value: column.key + '-asc'},
                {text: column.label + ' Desc', value: column.key + '-desc'}
              );
            }
          }
        });
      }
      return filter;
    },
  },
  methods: {
    updateFilter: function (key, value) {
      this.storeFilters = {...this.filters, [key]: value};
      this.$emit('filter', this.filters);
    },
    close: function () {
      this.open = false;
    },
  },
  watch: {
    sortBy: function (value) {
      this.updateFilter('order', value);
      this.$emit('sort', value);
    },
  },
  created: function () {
    if (this.defaultOrder && this.sortBy === null) {
      this.sortBy = this.defaultOrder;
    }
    this.$eb.$on('nav-state', (state) => {
      if (state === true) {
        this.open = false;
      }
    });
  },
  destroyed() {
    this.$eb.$off('nav-state');
  },
}
</script>

<style scoped lang="scss">

</style>
